import styled from "styled-components";
import ErrorPageBG from "../../assets/images/backGrounds/liveCourseRegisterBG.webp";
export const Styles = styled.div`
  #errorPage {
    position: absolute;
    top: 0;
    left: 0;
    background: url(${ErrorPageBG});
    height: 100vh;
    width: 100vw;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #errorPage .error-page-data {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    background: #fff;
    padding: 50px;
    border-radius: 35px;
  }
  #errorPage .error-page-data .logo {
    width: 240px;
    height: 120px;
  }
  #errorPage .error-page-data .logo img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  #errorPage .error-page-data .error-404 {
    height: 200px;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #errorPage .error-page-data .error-404 h1 {
    margin: 0px;
    position: absolute;
    left: 50%;
    font-size: 60px;
    transform: translateX(-50%);
    background: url(${ErrorPageBG}) no-repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: cover;
    background-position: center;
  }

  #errorPage .error-page-data p {
    margin-block: 20px;
    max-width: 500px;
  }

  @media (max-width: 768px) {
    #errorPage .error-page-data .error-404 {
      height: 120px;
    }
    #errorPage .error-page-data .error-404 h1 {
      font-size: 40px;
    }
  }
`;
